import { EventType } from '@/types';

export const isEventFinishedToday = (
  event: EventType,
  date?: Date | string | null,
) => {
  if (!date) return false;
  const now = new Date();
  const dateToCheck = new Date(date);
  const eventStartDate = new Date(event.dateFrom);
  const eventEndDate = new Date(event.dateTo);

  if (dateToCheck < eventStartDate || dateToCheck > eventEndDate) {
    return false;
  }

  const isToday =
    now.getFullYear() === dateToCheck.getFullYear() &&
    now.getMonth() === dateToCheck.getMonth() &&
    now.getDate() === dateToCheck.getDate();
  if (isToday && event.timeTo) {
    const [hours, minutes] = event.timeTo.split(':').map(Number);
    if (
      now.getHours() > hours ||
      (now.getHours() === hours && now.getMinutes() >= minutes)
    ) {
      return true;
    }
  }
  return false;
};
